<template>
    <div class="card-pembayaran-edc-wrapper" v-if="listPembayaranEdc.length > 0">
        <div v-for="(data, idx) in listPembayaranEdc" :key="`${idx}-${data.idbayar_edc}`" class="card-mesin">
            <SOSlotCard
                :id="`card-pembayaran-${data.idbayar_edc}`"
                :last-id="getLastId"
                :card-type="typeCard"
                @loadMore="doLoadMore"
                @toogleCard="toogleCard"
            >
                <template v-slot:card_body>
                    <div class="f-c-midgrey f-regular f-13 p-x-2" @click="gotoDetail(data.idtransaksi)">
                        <div class="d-flex-between-center f-16 f-semi f-c-black heading-card">
                            <div class="heading-left">
                                <label class="m-d-0">
                                    {{ getLabel(data) }}
                                    <svg
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M7.5 15L12.5 10L7.5 5"
                                            stroke="#C8D0DD"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                    </svg>
                                </label>
                            </div>
                            <div class="heading-right">
                                <p
                                    class="m-d-0 text-right"
                                    :class="{ minus: isVoid(data), plus: !isVoid(data), delete: isDelete(data) }"
                                >
                                    {{ data.nominal | currency }}
                                </p>
                            </div>
                        </div>
                        <div>
                            <label class="m-d-0">{{ data.idtransaksi }} • {{ data.nama_outlet }}</label>
                        </div>
                        <div>
                            <label class="m-d-0">{{ data.waktu_pembayaran }} oleh {{ getNamaKaryawan(data) }}</label>
                        </div>
                    </div>
                </template>
                <template v-slot:before_head v-if="isDelete(data)">
                    <div class="hapus-nota p-x-2 f-12 f-regular">Nota terhapus • {{ jenisRefund(data) }}</div>
                </template>
            </SOSlotCard>
            <div class="separator-line" style="margin-left: 20px; margin-right: 20px;"></div>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotCard from "@/so-components/global/slot/SOSlotCard.vue";

import { moduleName } from "../store/state";
export default {
    name: "SOCardPembayaranEdc",
    props: {
        typeCard: {
            type: String,
            default: "none",
        },
    },
    components: {
        SOSlotCard,
    },
    computed: {
        ...mapGetters(moduleName, {
            isFetching: "isFetching",
            listPembayaranEdc: "listPembayaranEdc",
            totalPembayaranEdc: "totalPembayaranEdc",
            endPembayaranOfPage: "endPembayaranOfPage",
            paginationRiwayatPembayaran: "paginationRiwayatPembayaran",
        }),
        getNamaKaryawan() {
            return (data) => {
                return data.nama_karyawan ? data.nama_karyawan : "Owner";
            };
        },
        getLabel() {
            return (data) => {
                return data.label;
            };
        },
        isVoid() {
            return (data) => {
                return data.is_void_transaction === 1 ? true : false;
            };
        },
        isDelete() {
            return (data) => {
                return data.hapus === 1 ? true : false;
            };
        },
        jenisRefund() {
            return (data) => {
                switch (data.tipe) {
                    case 2:
                        return "Refund kas laci";

                    case 1:
                        return "Void Transaction";
                }
            };
        },
        getLastId() {
            return this.endPembayaranOfPage.idbayar_edc
                ? `card-pembayaran-${this.endPembayaranOfPage.idbayar_edc}`
                : "";
        },
    },
    methods: {
        ...mapActions({
            setLoadMore: `${moduleName}/setLoadMore`,
            getRiwayatPembayaranEdc: `${moduleName}/getRiwayatPembayaranEdc`,
            toogleDisplayCard: `${moduleName}/toogleDisplayCard`,
        }),
        async doLoadMore() {
          if (this.totalPembayaranEdc > this.paginationRiwayatPembayaran.length) {
                if (!this.isFetching) {
                    await this.setLoadMore(true);
                    await this.getRiwayatPembayaranEdc({ idedc: this.$route.params.id_mesin });
                }
            }
        },
        toogleCard(data) {
            this.toogleDisplayCard(data);
        },
        gotoDetail(dataId) {
            this.$router.push({ name: "TransaksiDetail", params: { idtransaksi: dataId } });
        },
    },
};
</script>
<style scoped>
.p-x-2 {
    padding-left: 2px;
    padding-right: 2px;
}
.minus {
    color: #da1e28;
}
.minus::before {
    content: "- ";
}
.plus {
    color: #24a148;
}
.plus::before {
    content: "+ ";
}
.delete {
    color: black;
}
.delete::before {
    content: "+ ";
}
.hapus-nota {
    color: #964040;
    background-color: #fff1f1;
    width: fit-content;
    padding: 0px 4px;
}

.heading-card .heading-left {
    max-width: 100px;
}

.heading-card .heading-right {
    width: fit-content;
}
@media (min-width: 330px) {
    .heading-card .heading-left {
        max-width: unset;
    }
}
</style>
